import React from "react";

const processSteps = [
  {
    step: "01",
    title: "Advanced Manufacturing",
    desc: "In-house manufacturing facilities equipped with modern machinery ensure consistency, safety, and large-scale production."
  },
  {
    step: "02",
    title: "Raw Material Selection",
    desc: "Only high-grade, approved raw materials are sourced to maintain product purity, effectiveness, and environmental safety."
  },
  {
    step: "03",
    title: "Strict Quality Testing",
    desc: "Every batch undergoes rigorous laboratory testing to meet performance, safety, and regulatory standards."
  },
  {
    step: "04",
    title: "Controlled Packaging",
    desc: "Automated and hygienic packaging systems preserve product quality and ensure safe handling."
  },
  {
    step: "05",
    title: "Regulatory Compliance",
    desc: "All products comply with agricultural regulations and ISO quality standards for reliability and farmer trust."
  },
  {
    step: "06",
    title: "Continuous Improvement",
    desc: "Ongoing research, feedback analysis, and innovation help us improve formulations and performance."
  }
];

const ManufacturingProcess = () => {
  return (
    <section className="manufacturing-section">
      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <h6 className="section-subtitle">MANUFACTURING & QUALITY</h6>
          <h2 className="section-title">
            From <span>Production</span> to Field Performance
          </h2>
          <p className="section-desc">
            Our manufacturing and quality processes are designed to deliver
            safe, effective, and reliable agricultural solutions that farmers
            can trust in real field conditions.
          </p>
        </div>

        {/* PROCESS STEPS */}
        <div className="row">
          {processSteps.map((item, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="process-card">
                <span className="process-step">{item.step}</span>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ManufacturingProcess;
